// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"73":"d65373d3","371":"36db920f"}[chunkId] + ".chunk.js");